// We get visitorId from local storage, if it doesn't exist we generate a new one and save it to local storage
export const useVisitorId = () => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const visitorId = localStorage.getItem('ricos-playground-visitor-id');
  if (visitorId) {
    return visitorId;
  } else {
    const newVisitorId = uuid();
    localStorage.setItem('ricos-playground-visitor-id', newVisitorId);
    return newVisitorId;
  }
};

const uuid = (): string => {
  let d = new Date().getTime();
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    // eslint-disable-next-line no-bitwise
    const r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    // eslint-disable-next-line no-bitwise
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });
};
